<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="9">
        <b-form-group>
          <b-input-group>
            <b-form-input
              type="text"
              placeholder="Search"
              @keyup="filterList"
              v-model="searchString"
            />

            <b-input-group-append>
              <b-input-group-text>
                <i
                  class="fa fa-times appendIcon clickIcon"
                  @click="resetSearch"
                ></i>
              </b-input-group-text>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col lg="3">
        <div class="form-group form-actions float-right pb-2">
          <b-button
            class="mr-2"
            type="submit"
            size="md"
            variant="primary"
            @click="newEntity"
          >
            <i class="fa fa-group-arrows-rotate"></i>
            New Dealer Group
          </b-button>
        </div>
        <div>
          <StyledDialog
            @filterList="filterList"
            :CurrentObject="mySelected"
            EntityType="DealerGroup"
          >
            <div slot="header">
              <h2>{{ mySelected.Name }}</h2>
            </div>
            <div slot="details">
              <!-- <div>{{mySelected.Email1}}</div> -->
            </div>
            <span slot="entityType">Dealer Group</span>
          </StyledDialog>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12">
        <b-table
          @row-clicked="myRowClickHandler"
          :items="filteredObjects"
          :fields="fields"
          hover
          small
          fixed
          caption
          selectable
          select-mode="single"
          responsive="sm"
          selectedVariant="success"
          :current-page="currentPage"
          :per-page="perPage"
        >
          <template slot="Functions" slot-scope="data">
            <i
              v-b-tooltip
              title="Delete"
              class="fa fa-trash-o"
              v-b-modal.modal-2
              @click="SetItemToDelete(data.item)"
            ></i>
          </template>
        </b-table>

        <nav v-show="isNavVisible">
          <b-pagination
            :per-page="perPage"
            :total-rows="totalRows"
            v-model="currentPage"
            prev-text="Prev"
            next-text="Next"
            hide-goto-end-buttons
          />
        </nav>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import cTable from "@/views/base/Table.vue";
//import DeleteDialog from "@/components/dialogs/DeleteDialog.vue";
//import MyBaseTable from "@/components/base/MyBaseTable.vue";
import StyledDialog from "@/components/dialogs/StyledModal.vue";
import { required, email, minLength, helpers } from "vuelidate/lib/validators";

export default {
  name: "DealerGroupList",
  data: () => {
    return {
      fields: [
        {
          key: "Functions",
          label: "",
          sortable: false,
          thStyle: "width: 5%;",
          thClass: "ellipse_cell",
          tdClass: "ellipse_cell"
        },
        {
          key: "Name",
          label: "Dealer Group Name",
          sortable: true,
          thStyle: "width: 30%;",
          thClass: "ellipse_cell",
          tdClass: "ellipse_cell"
        },
        {
          key: "Notes",
          label: "Notes",
          sortable: true,
          thStyle: "width: 40%;",
          thClass: "ellipse_cell",
          tdClass: "ellipse_cell"
        }
      ],
      mySelected: {},
      currentPage: 1,
      perPage: 25,
      filteredObjects: [],
      searchString: ""
    };
  },
  props: {},
  components: {
    cTable,
    StyledDialog
    //MyBaseTable
  },
  created() {
    //console.log(this.$route);
    this.myLoadComponent();
  },
  computed: {
    totalRows: function() {
      return this.$store.state.dealer.dealergroups.length;
    },
    totalRowsFiltered: function() {
      return this.filteredObjects.length;
    },
    isNavVisible: function() {
      return this.totalRowsFiltered > this.perPage;
    },
    ...mapState(["n_user", "dealer", "notification"]),
    ...mapActions("notification", ["add", "remove"])
  },
  // computed: mapState({
  //   users: state => state.n_user.n_users,
  //   items: state => state.n_user.n_users,
  //   itemsArray: state => state.n_user.n_users
  // }),
  updated() {
    this.incrementCount;
  },
  methods: {
    async myLoadComponent() {
      await this.$store.dispatch("dealer/fetchDealerGroups");
      this.filterList();
    },
    myRowClickHandler(record, index) {
      // 'record' will be the row data from items
      // `index` will be the visible row number (available in the v-model 'shownItems')
      this.$store
        .dispatch("dealer/loadDealerGroupEdit", record.DealerGroupID)
        .then(() => {
          this.$router.push({ name: "DealerGroupProfile" });
        });
    },
    newEntity() {
      this.$store
        .dispatch("dealer/newDealerGroup", this.createFreshObject())
        .then(() => {
          this.$router.push({ name: "DealerGroupProfile" });
          //,
          //params: { id: this.event.id }
        })
        .catch(() => {
          console.log("There was a problem");
          //.dispatch('notification/add', this.event)
        });
    },
    SetItemToDelete(object) {
      this.mySelected = object;
    },
    createFreshObject() {
      return {
        DealerGroupID: -1,
        Name: "",
        Members: []
      };
    },
    filterList: function() {
      this.filteredObjects = this.$store.state.dealer.dealergroups.filter(
        dealergroup =>
          dealergroup.Name.toLowerCase().indexOf(
            this.searchString.toLowerCase()
          ) > -1 ||
          dealergroup.Notes.toLowerCase().indexOf(
            this.searchString.toLowerCase()
          ) > -1
      );
    },
    resetSearch: function() {
      this.searchString = "";
      this.filterList();
    }
  }
};
</script>

<style scoped>
.my-tbl-function {
  width: 10% !important;
  color: red;
}
.testred {
  color: red;
  border-color: red;
}
</style>
